var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );
dependencies["header/left-primary-navigation-toggle.j2"] = require( "header/left-primary-navigation-toggle.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/left-primary-navigation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/macros/left-primary-navigation.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
output += "\n";
env.getTemplate("macros/navigation-items.j2", false, "core/templates/macros/left-primary-navigation.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("renderNavItem")) {
var t_8 = t_5.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_8);
var macro_t_9 = runtime.makeMacro(
["slugs"], 
["level", "levelLimit", "selectedLevel1Slug", "class", "inContainer"], 
function (l_slugs, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("slugs", l_slugs);
frame.set("level", kwargs.hasOwnProperty("level") ? kwargs["level"] : 1);
frame.set("levelLimit", kwargs.hasOwnProperty("levelLimit") ? kwargs["levelLimit"] : 2);
frame.set("selectedLevel1Slug", kwargs.hasOwnProperty("selectedLevel1Slug") ? kwargs["selectedLevel1Slug"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("inContainer", kwargs.hasOwnProperty("inContainer") ? kwargs["inContainer"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_10 = "";t_10 += "\n\n    ";
t_10 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "level") <= runtime.contextOrFrameLookup(context, frame, "levelLimit") || runtime.contextOrFrameLookup(context, frame, "inContainer")) {
t_10 += "\n\n        ";
var t_11;
t_11 = ((runtime.contextOrFrameLookup(context, frame, "level") == 1)?runtime.contextOrFrameLookup(context, frame, "True"):runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("islevelOne", t_11, true);
if(frame.topLevel) {
context.setVariable("islevelOne", t_11);
}
if(frame.topLevel) {
context.addExport("islevelOne", t_11);
}
t_10 += "\n\n        <ul class=\"";
t_10 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "islevelOne")?"o-accordion js-accordion":""), env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul", env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul--level", env.opts.autoescape);
t_10 += "-";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_10 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_10 += "itemscope itemtype=\"http://www.schema.org/SiteNavigationElement\"";
;
}
t_10 += " data-qa-main-navigation >\n\n        ";
frame = frame.push();
var t_14 = l_slugs;
if(t_14) {var t_13 = t_14.length;
for(var t_12=0; t_12 < t_14.length; t_12++) {
var t_15 = t_14[t_12];
frame.set("slug", t_15);
frame.set("loop.index", t_12 + 1);
frame.set("loop.index0", t_12);
frame.set("loop.revindex", t_13 - t_12);
frame.set("loop.revindex0", t_13 - t_12 - 1);
frame.set("loop.first", t_12 === 0);
frame.set("loop.last", t_12 === t_13 - 1);
frame.set("loop.length", t_13);
t_10 += "\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_15)) {
t_10 += "\n\n                ";
var t_16;
t_16 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_15);
frame.set("navItem", t_16, true);
if(frame.topLevel) {
context.setVariable("navItem", t_16);
}
if(frame.topLevel) {
context.addExport("navItem", t_16);
}
t_10 += "\n\n                ";
t_10 += runtime.suppressValue((lineno = 36, colno = 64, runtime.callWrap(t_8, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_17 = runtime.makeMacro(
["currentNavItem", "url", "target"], 
[], 
function (l_currentNavItem, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("currentNavItem", l_currentNavItem);
frame.set("url", l_url);
frame.set("target", l_target);
var t_18 = "";t_18 += "\n\n                    ";
var t_19;
t_19 = runtime.contextOrFrameLookup(context, frame, "islevelOne") && env.getFilter("length").call(context, runtime.memberLookup((l_currentNavItem),"childSlugs")) == 0;
frame.set("hasNoChildren", t_19, true);
if(frame.topLevel) {
context.setVariable("hasNoChildren", t_19);
}
if(frame.topLevel) {
context.addExport("hasNoChildren", t_19);
}
t_18 += "\n                    ";
var t_20;
t_20 = runtime.contextOrFrameLookup(context, frame, "islevelOne") && runtime.memberLookup((l_currentNavItem),"typeCode") == "HEADING";
frame.set("isHeading", t_20, true);
if(frame.topLevel) {
context.setVariable("isHeading", t_20);
}
if(frame.topLevel) {
context.addExport("isHeading", t_20);
}
t_18 += "\n                    ";
var t_21;
t_21 = (lineno = 40, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.headerFeatureConfig.twoHitState",runtime.contextOrFrameLookup(context, frame, "True")]));
frame.set("hasTwoHitStates", t_21, true);
if(frame.topLevel) {
context.setVariable("hasTwoHitStates", t_21);
}
if(frame.topLevel) {
context.addExport("hasTwoHitStates", t_21);
}
t_18 += "\n                    ";
var t_22;
t_22 = runtime.contextOrFrameLookup(context, frame, "islevelOne") && (runtime.contextOrFrameLookup(context, frame, "isHeading") || !runtime.contextOrFrameLookup(context, frame, "hasTwoHitStates")) && (!runtime.contextOrFrameLookup(context, frame, "hasNoChildren"));
frame.set("isAccordionTab", t_22, true);
if(frame.topLevel) {
context.setVariable("isAccordionTab", t_22);
}
if(frame.topLevel) {
context.addExport("isAccordionTab", t_22);
}
t_18 += "\n                    ";
var t_23;
t_23 = "noopener noreferrer";
frame.set("rel", t_23, true);
if(frame.topLevel) {
context.setVariable("rel", t_23);
}
if(frame.topLevel) {
context.addExport("rel", t_23);
}
t_18 += "\n\n                    <li class=\"";
t_18 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "islevelOne")?"o-accordion__tabset js-accordion-tabset is-collapsed":""), env.opts.autoescape);
t_18 += " ";
t_18 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__li", env.opts.autoescape);
t_18 += " ";
t_18 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__li--level-" + "" + runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_18 += "\">\n\n                        ";
var t_24;
t_24 = (lineno = 46, colno = 59, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug")]));
frame.set("rootRelativePath", t_24, true);
if(frame.topLevel) {
context.setVariable("rootRelativePath", t_24);
}
if(frame.topLevel) {
context.addExport("rootRelativePath", t_24);
}
t_18 += "\n                        ";
var t_25;
t_25 = env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + runtime.contextOrFrameLookup(context, frame, "rootRelativePath")));
frame.set("canonicalUrl", t_25, true);
if(frame.topLevel) {
context.setVariable("canonicalUrl", t_25);
}
if(frame.topLevel) {
context.addExport("canonicalUrl", t_25);
}
t_18 += "\n\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"isContainer")) {
t_18 += "\n\n                            <span class=\"";
t_18 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__span--is-container", env.opts.autoescape);
t_18 += "\">";
t_18 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_18 += "</span>\n\n                        ";
;
}
else {
t_18 += "\n\n                            <a ";
if(l_target) {
t_18 += "target=\"";
t_18 += runtime.suppressValue(l_target, env.opts.autoescape);
t_18 += "\" ";
if(l_target == "_blank") {
t_18 += " rel=\"";
t_18 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_18 += "\" ";
;
}
;
}
t_18 += "\n\n                                ";
t_18 += runtime.suppressValue((lineno = 57, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 57, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"top_nav_l" + "" + runtime.contextOrFrameLookup(context, frame, "level") + "" + " click",runtime.memberLookup((l_currentNavItem),"gaLabel")])), env.opts.autoescape);
t_18 += "\n\n                                class=\"";
t_18 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
t_18 += " ";
t_18 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a--level-" + "" + runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_18 += "\n                                       ";
t_18 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "hasNoChildren")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a--no-children":""), env.opts.autoescape);
t_18 += "\" href=\"";
t_18 += runtime.suppressValue(l_url, env.opts.autoescape);
t_18 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_18 += "itemprop=\"url\"";
;
}
t_18 += ">\n\n                                <span class=\"\n                                    ";
t_18 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__span", env.opts.autoescape);
t_18 += "\n                                    ";
t_18 += runtime.suppressValue("c-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__span--level-" + "" + runtime.contextOrFrameLookup(context, frame, "level"), env.opts.autoescape);
t_18 += "\n                                    ";
t_18 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "isAccordionTab")?"js-accordion-tab":""), env.opts.autoescape);
t_18 += "\n                                    ";
t_18 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "hasNoChildren")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__span--no-children":""), env.opts.autoescape);
t_18 += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_18 += "itemprop=\"name\"";
;
}
t_18 += ">";
t_18 += runtime.suppressValue(runtime.memberLookup((l_currentNavItem),"displayName"), env.opts.autoescape);
t_18 += "</span>\n\n                                ";
if(runtime.contextOrFrameLookup(context, frame, "islevelOne")) {
t_18 += "\n\n                                    <div class=\"";
t_18 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__control", env.opts.autoescape);
t_18 += " ";
t_18 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "hasNoChildren")?"c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__control--no-children":""), env.opts.autoescape);
t_18 += " js-accordion-tab\">\n\n                                       ";
env.getTemplate("header/left-primary-navigation-toggle.j2", false, "core/templates/macros/left-primary-navigation.j2", null, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
t_26.render(context.getVariables(), frame, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_18 += t_27
t_18 += "\n\n                                    </div>\n\n                                ";
})});
}
t_18 += "\n\n                            </a>\n\n                        ";
;
}
t_18 += "\n\n                        ";
t_18 += "\n                        ";
var t_30;
t_30 = (lineno = 83, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "concat_lists"), "concat_lists", context, [runtime.memberLookup((l_currentNavItem),"childSlugs"),(lineno = 83, colno = 105, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_currentNavItem,"containerInfo",[]]))]));
frame.set("currentNavChildSlugs", t_30, true);
if(frame.topLevel) {
context.setVariable("currentNavChildSlugs", t_30);
}
if(frame.topLevel) {
context.addExport("currentNavChildSlugs", t_30);
}
t_18 += "\n\n                        ";
t_18 += "\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "currentNavChildSlugs")) {
t_18 += "\n\n                            <div class=\"o-accordion__panel ";
t_18 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__panel", env.opts.autoescape);
t_18 += " js-accordion-panel\" aria-labelledby=\"level-1__tab\" aria-hidden=\"false\" role=\"tabpanel\">\n\n                                ";
t_18 += runtime.suppressValue((lineno = 90, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "buildLeftPrimaryNavigation"), "buildLeftPrimaryNavigation", context, [runtime.contextOrFrameLookup(context, frame, "currentNavChildSlugs"),runtime.makeKeywordArgs({"level": runtime.contextOrFrameLookup(context, frame, "level") + 1,"selectedLevel1Slug": runtime.contextOrFrameLookup(context, frame, "selectedLevel1Slug"),"class": runtime.contextOrFrameLookup(context, frame, "class"),"inContainer": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"isContainer")})])), env.opts.autoescape);
t_18 += "\n\n                            </div>\n\n                        ";
;
}
t_18 += "\n\n                    </li>\n\n                ";
;
frame = frame.pop();
return new runtime.SafeString(t_18);
});
return macro_t_17;})()})])), env.opts.autoescape);
t_10 += "\n\n            ";
;
}
t_10 += "\n\n        ";
;
}
}
frame = frame.pop();
t_10 += "\n\n        </ul>\n\n    ";
;
}
t_10 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("buildLeftPrimaryNavigation");
context.setVariable("buildLeftPrimaryNavigation", macro_t_9);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/left-primary-navigation.j2"] , dependencies)